

type MenuIcon = {
    active?: boolean;
    action?: (param?: any) => void
}


export function LightIcon({ active = false, action }: MenuIcon) {
    return (
        <svg
            onClick={() => action && action()}
            width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 7.84253C10.3438 7.03003 10.5 6.43628 10.5 6.03003C10.5 3.56128 8.46875 1.53003 6 1.53003C3.5 1.53003 1.5 3.56128 1.5 6.03003C1.5 6.43628 1.625 7.03003 1.96875 7.84253C2.28125 8.59253 2.75 9.46753 3.28125 10.3425C4.1875 11.78 5.21875 13.155 6 14.155C6.75 13.155 7.78125 11.78 8.6875 10.3425C9.21875 9.46753 9.6875 8.59253 10 7.84253ZM6.71875 15.655C6.34375 16.1238 5.625 16.1238 5.25 15.655C3.65625 13.6238 0 8.78003 0 6.03003C0 2.71753 2.6875 0.0300293 6 0.0300293C9.3125 0.0300293 12 2.71753 12 6.03003C12 8.78003 8.34375 13.6238 6.71875 15.655Z" fill="#6E7586" />
        </svg>

    )
}